function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import JSONLDAbstractNode from "../JSONLDAbstractNode";
import { encode } from "he";

var GenericNode = /*#__PURE__*/function (_JSONLDAbstractNode) {
  _inheritsLoose(GenericNode, _JSONLDAbstractNode);

  function GenericNode() {
    return _JSONLDAbstractNode.apply(this, arguments) || this;
  }

  var _proto = GenericNode.prototype;

  _proto.getJSON = function getJSON(_ref) {
    var _ref4;

    var type = _ref.type,
        jsonldtype = _ref.jsonldtype,
        schema = _objectWithoutPropertiesLoose(_ref, ["type", "jsonldtype"]);

    var parseChildren = _JSONLDAbstractNode.prototype.parseChildren.call(this);

    var details = _objectSpread({
      "@type": jsonldtype || this.getSchemaOrgType()
    }, schema); // delete props that are `null`


    Object.keys(details).forEach(function (key) {
      if (details[key] === null) delete details[key];
    }); // escape string prop values

    var clearProps = Object.assign.apply(Object, Object.entries(details).map(function (_ref2) {
      var _ref3;

      var key = _ref2[0],
          value = _ref2[1];
      return _ref3 = {}, _ref3[key] = typeof value === "string" ? encode(value) : value, _ref3;
    }));
    return type ? Object.assign.apply(Object, [(_ref4 = {}, _ref4[type] = clearProps, _ref4)].concat(parseChildren)) : Object.assign.apply(Object, [clearProps].concat(parseChildren));
  };

  return GenericNode;
}(JSONLDAbstractNode);

export default GenericNode;